/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Set_IncodeInputs */



/**
* | output |
* | --- |
* | "Set Incode (Start)" |
*
* @param {Shortcut_Keys_Name_Set_IncodeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_set_incode = /** @type {((inputs?: Shortcut_Keys_Name_Set_IncodeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Set_IncodeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Definir l'incode (debut)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Set Incode (Start)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Imposta Incode (Avvia)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Установить код ввода (Начало)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Establecer Incode (Inicio)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("设置 Incode（开始）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("インコードの設定（開始）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इनकोड सेट करें (प्रारंभ)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Definir código de entrada (Início)")
	return /** @type {LocalizedString} */ ("Set Incode (Start)")
});